// works with React Hook Form fields
export const focusNextElement = (
  e: any,
  formValues: any,
  setFocus: (name: string) => void
) => {
  if (e.key !== "Enter") {
    return
  }
  const formElementNames = Object.keys(formValues)
  const currentElementName = e.target.name
  const currentElementIndex = formElementNames.indexOf(currentElementName)
  if (currentElementIndex + 1 < formElementNames.length) {
    setFocus(formElementNames[currentElementIndex + 1])
  }
}
